import React, { useState, useEffect } from "react";
import { Box, Chip, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import MaterialTable from "../../../Components/MaterialTable";
import { IColumn } from "../../../Components/MaterialTable/MaterialTable";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
import { TRANSACTION_TYPE } from "../../../constants";
import { TRANSACTION_TYPE_ENUM } from "../../../store/services/invitations/dto/invitations.dto";
import { useLazyGetTransactionsQuery } from "../../../store/services/transactions/transactions.service";
import { Transaction } from "../../../store/services/transactions/dto/transactions.dto";
import { useAppSelector } from "../../../store";
import { getFullTransactionState } from "../../../store/slices/transactions/transactions.slice";
import TransactionsCardsList from "./TransactionsCardsList";
const columns: Array<IColumn<Transaction>> = [
	{
		label: "Transaction ID",
		dataKey: "transactionId",
		Cell: ({ rowData }) => <Typography fontSize={13}>{rowData.transactionId}</Typography>
	},
	{
		label: "Order ID",
		dataKey: "orderId",
		Cell: ({ rowData }) => <Typography fontSize={13}>{rowData.orderId}</Typography>
	},
	{
		label: "Invitation ID",
		dataKey: "invitation_id",
		Cell: ({ rowData }) => (
			<Link
				to={`/manageWeddingInvitation/${rowData.invitation_id}`}
				style={{ fontSize: 13, color: "#1976d2", textDecoration: "none", fontWeight: 500 }}
			>
				{rowData.invitation_id}
			</Link>
		)
	},
	{
		label: "Type",
		dataKey: "type",
		Cell: ({ rowData }) => (
			<Chip
				label={TRANSACTION_TYPE[rowData.type]}
				color={rowData.type === TRANSACTION_TYPE_ENUM.PAYMENT ? "success" : "warning"}
				size={"small"}
			/>
		)
	},
	{
		label: "Amount",
		dataKey: "amount",
		Cell: ({ rowData }) => (
			<Typography fontSize={13} fontWeight={500}>
				{formatCurrency(rowData.amount, rowData.currency)}
			</Typography>
		)
	},

	{
		label: "Date",
		dataKey: "createdAt",
		Cell: ({ rowData }) => <Typography fontSize={13}>{formatDate(rowData.createdAt, "Africa/Cairo", "PP")}</Typography>
	}
];
const ROWS_PER_PAGE = 10;
const Transactions = () => {
	const [page, setPage] = useState(1);
	const [callFetchTransactions] = useLazyGetTransactionsQuery();
	const { transactions, totalItems, loadingTransactions } = useAppSelector(getFullTransactionState);
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));

	useEffect(() => {
		callFetchTransactions({ page: 1, perPage: 10 });
	}, []);

	const handlePageChange = (page: number) => {
		if (page > 0) {
			setPage(page);
			callFetchTransactions({ page, perPage: ROWS_PER_PAGE });
		}
	};

	return (
		<Box>
			{isSmallerScreen ? (
				<TransactionsCardsList
					data={transactions || []}
					page={page}
					perPage={ROWS_PER_PAGE}
					totalItems={totalItems || 0}
					onPageChange={handlePageChange}
					isLoading={loadingTransactions}
				/>
			) : (
				<MaterialTable
					tableLabel={"My Transactions"}
					columns={columns}
					data={transactions || []}
					page={page}
					rowsPerPage={ROWS_PER_PAGE}
					totalItems={totalItems || 0}
					onPageChange={handlePageChange}
					isLoading={loadingTransactions}
				/>
			)}
		</Box>
	);
};

export default Transactions;
